import Vue from "vue";
import VueRouter from "vue-router";
import { ensureWechatSdk } from "../utils/wechat-sdk";


Vue.use(VueRouter);
//cv以下代码解决路由地址重复的报错问题(一劳永逸)
// const originalPush = VueRouter.prototype.push
//   VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const routes = [

    {
        path: "/",
        name: "project",
        redirect: '/projectindex',
        component: () => import('../views/projectindex/project.vue'),
        hidden: true,
        meta: {
            title: "项目管理系统",
            content: {
                keywords: '项目管理、项目管理系统、项目管理软件、项目管理工具、Project Management、PMP管理系统、PMI管理系统、PMIS系统、PMP、PMI、PMIS',
                description: '符合PMI管理规范的项目管理系统，提供全套项目管理解决方案。'
            }
        },
        children: [
            {
                path: "/AboutUs",
                name: "AboutIchuk",

                component: () => import('../views/projectindex/AboutIchuk.vue'),
                hidden: true,
                meta: {
                    title: "关于我们",

                }
            },
            {
                path: "/download",
                name: "download",

                component: () => import('../views/projectindex/download.vue'),
                hidden: true,
                meta: {
                    title: "访问与客户端",

                }
            },
            {
                path: "/solution",
                name: "solution",

                component: () => import('../views/projectindex/solution.vue'),
                hidden: true,
                meta: {
                    title: "解决方案",

                }
            },
            {
                path: "/solution2",
                name: "solution2",

                component: () => import('../views/projectindex/solution2.vue'),
                hidden: true,
                meta: {
                    title: "解决方案",

                }
            },
            {
                path: "/solution3",
                name: "solution3",

                component: () => import('../views/projectindex/solution3.vue'),
                hidden: true,
                meta: {
                    title: "解决方案",

                }
            },
            {
                path: "/solution4",
                name: "solution4",

                component: () => import('../views/projectindex/solution4.vue'),
                hidden: true,
                meta: {
                    title: "解决方案",

                }
            },
            {
                path: "/projectprice",
                name: "projectprice",

                component: () => import('../views/projectindex/projectprice.vue'),
                hidden: true,
                meta: {
                    title: "价格",

                }
            },
            {
                path: "/helpcenter",
                name: "helpcenter",

                component: () => import('../views/projectindex/helpcenter.vue'),
                hidden: true,
                meta: {
                    title: "帮助中心",

                }
            },

            {
                path: "/updatelog",
                name: "updatelog",

                component: () => import('../views/projectindex/updatelog.vue'),
                hidden: true,
                meta: {
                    title: "更新日志",

                }
            },
            {
                path: "/projectindex",
                name: "projectindex",

                component: () => import('../views/projectindex/projectindex.vue'),
                hidden: true,
                meta: {
                    title: "项目管理系统",
                    content: {
                        keywords: '项目管理、项目管理系统、项目管理软件、项目管理工具、Project Management、PMP管理系统、PMI管理系统、PMIS系统、PMP、PMI、PMIS',
                        description: '符合PMI管理规范的项目管理系统，提供全套项目管理解决方案。'
                    }
                }
            },
            {
                path: "/threelizi",
                name: "threelizi",

                component: () => import('../views/projectindex/threelizi.vue'),
                hidden: true,
                meta: {
                    title: "项目管理系统",
                    content: {
                        keywords: '项目管理、项目管理系统、项目管理软件、项目管理工具、Project Management、PMP管理系统、PMI管理系统、PMIS系统、PMP、PMI、PMIS',
                        description: '符合PMI管理规范的项目管理系统，提供全套项目管理解决方案。'
                    }
                }
            },
        ],
    },


    {
        path: "/404",
        name: "404",
        component: () => import('../views/404.vue'),
        //component: Login,
        hidden: true,
        meta: {
            title: "404"
        }
    },
    {
        path: "/Login",
        name: "Login",
        component: () => import('../views/login.vue'),
        //component: Login,
        hidden: true,
        meta: {
            title: "登录"
        }
    },
    {
        path: "/companyinvite",
        name: "companyinvite",
        component: () => import('../views/companyinvite.vue'),
        //component: Login,
        hidden: true,
        meta: {
            title: "companyinvite"
        }
    },
    {
        path: "/register",
        name: "register",
        component: () => import('../views/register.vue'),
        //component: register,
        hidden: true,
        meta: {
            title: "注册"
        }
    },
    {
        path: "/registerAgreement",
        name: "registerAgreement",
        component: () => import('../views/registerAgreement.vue'),
        //component: registerAgreement,
        hidden: true,
        meta: {
            title: "用户协议"
        }
    },
    {
        path: "/forget_password",
        name: "忘记密码",
        component: () => import('../views/forget_password.vue'),
        //component: forgetPassword,
        hidden: true,
        meta: {
            title: "忘记密码-输入邮箱"
        }
    },
    {
        path: "/forget_pw",
        name: "忘记密码",
        component: () => import('../views/forget_pw.vue'),
        //component: forgetPw,
        hidden: true,
        meta: {
            title: "忘记密码-确认密码"
        }
    },
    {
        path: "/qyvxLogin",
        name: "企业微信登录",
        component: () => import('../views/qyvxLogin.vue'),
        //component: qyvxLogin,
        hidden: true,
        meta: {
            title: "企业微信登录"
        }
    },
    {
        path: "/bindQyvx",
        name: "企业微信绑定手机号",
        component: () => import('../views/bindQyvx.vue'),
        //component: bindQyvx,
        hidden: true,
        meta: {
            title: "企业微信绑定手机号"
        }
    },
    {
        path: "/wxLogin",
        name: "微信登录",
        component: () => import('../views/wxLogin.vue'),
        //component: wxLogin,
        hidden: true,
        meta: {
            title: "微信登录"
        }
    },
    {
        path: "/bindWx",
        name: "微信绑定手机号",
        component: () => import('../views/bindWx.vue'),
        //component: bindWx,
        hidden: true,
        meta: {
            title: "微信绑定手机号"
        }
    },
    {
        path: "/project_view_board",
        name: "项目看板",
        component: () => import('../views/project_view_board.vue'),
        //component: project_view_board,
        hidden: true,
        meta: {
            title: "项目看板"
        }
    },
    // 客户平台
    {
        path: "/index",
        name: "欢迎页",
        component: () => import('../views/index.vue'),
        //component: Index,
        icon: 'el-icon-coin',
        meta: {
            title: "欢迎页"
        },
        children: [{
            path: "/management",
            name: "项目管理系统",
            icon: 'iconfont icon-ziyuan143',
            meta: {
                title: '项目管理系统'
            },
            component: () => import('../views/management.vue'),
            //component:Management,
        },
            {
                path: "/task_panel",
                name: "任务面板",
                component: () => import('../views/task_panel.vue'),
                //component: taskPanel,
                icon: 'iconfont icon-mianban',
                meta: {
                    title: "任务面板"
                },
            },
            {
                path: "/project",
                name: "项目",
                component: () => import('../views/project.vue'),
                //component: Project,
                icon: 'iconfont icon-wenjianjia',
                meta: {
                    title: "项目"
                },
            }, 
            {
                path: "/project_report_list",
                name: "项目报表",
                component: () => import('../views/project_report_list.vue'),
                //component: Project,
                icon: 'iconfont icon-wenjianjia',
                meta: {
                    title: "项目报表"
                },
            }, 
            {
                path: "/project_invite",
                name: "项目",
                component: () => import('../views/project_invite.vue'),
                //component: project_invite,
                icon: 'iconfont icon-wenjianjia',
                meta: {
                    title: "项目"
                },
            },
            {
                path: "/create_project_statistics",
                name: "项目报表",
                component: () => import('../views/create_project_statistics.vue'),
                //component: Project,
                icon: 'iconfont icon-wenjianjia',
                meta: {
                    title: "项目报表"
                },
            }, 
            {
                path: "/project_statistics_echarts",
                name: "项目统计报表",
                component: () => import('../views/project_statistics_echarts.vue'),
                //component: Project,
                icon: 'iconfont icon-wenjianjia',
                meta: {
                    title: "项目统计报表"
                },
            }, 
            {
                path: "/load_statistics_management",
                name: "工作负载统计报表",
                component: () => import('../views/load_statistics_management.vue'),
                //component: Project,
                icon: 'iconfont icon-wenjianjia',
                meta: {
                    title: "工作否负载统计报表"
                },
            }, 
            {
                path: "/message",
                name: "信息",
                component: () => import('../views/message.vue'),
                //component: Message,
                icon: 'iconfont icon-gerenxinxi',
                meta: {
                    title: "信息"
                },
            },
            {
                path: "/teamcompany",
                name: "团队/企业",
                component: () => import('../views/teamcompany.vue'),

                icon: 'iconfont icon-gerenxinxi',
                meta: {
                    title: "团队/企业"
                },
            },
            {
                path: "/account",
                name: "账户",
                component: () => import('../views/account.vue'),
                //component: Account,
                icon: 'iconfont icon-zhanghumima',
                meta: {
                    title: "账户"
                },
            },
            {
                path: "/my_panel",
                name: "我的面板",
                component: () => import('../views/my_panel.vue'),
                // component: myPanel,
                hidden: true,
                icon: '',
                meta: {
                    title: "我的面板",
                    content: {
                        viewport: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
                    }
                },
            },
            {
                path: "/project_center",
                name: "项目中心",
                component: () => import('../views/project_center.vue'),
                // component: projectCenter,
                hidden: true,
                icon: '',
                meta: {
                    title: "项目中心",

                },
            },
            {
                path: "/resource_center",
                name: "资源中心",
                component: () => import('../views/resource_center.vue'),
                // component: resourceCenter,
                hidden: true,
                icon: '',
                meta: {
                    title: "资源中心"
                },
            },
            {
                path: "/OAapply",
                redirect: "/OAapplyWorkOvertime",
                name: "OA面板",
                component: () => import('../views/OAapply.vue'),
                // component: resourceCenter,
                hidden: true,
                icon: '',
                meta: {
                    title: "OA面板"
                },
                children: [{
                    path: "/OAapplyWorkOvertime",
                    name: "OA-加班列表",
                    component: () => import('../views/OAapplyWorkOvertime.vue'),
                    // component: projectInfomation,
                    hidden: true,
                    icon: '',
                    meta: {
                        title: "OA-加班列表"
                    },
                }, {
                    path: "/OAapplyLeave",
                    name: "OA-请假列表",
                    component: () => import('../views/OAapplyLeave.vue'),
                    // component: projectInfomation,
                    hidden: true,
                    icon: '',
                    meta: {
                        title: "OA-请假列表"
                    },
                }, {
                    path: "/OAApplyExpenses",
                    name: "OA-报销列表",
                    component: () => import('../views/OAApplyExpenses.vue'),
                    // component: projectInfomation,
                    hidden: true,
                    icon: '',
                    meta: {
                        title: "OA-报销列表"
                    },
                }],
            },
            {
                path: "/project_resource_map",
                name: "项目资源图",
                component: () => import('../views/project_resource_map.vue'),
                // component: projectResourceMap,
                hidden: true,
                icon: '',
                meta: {
                    title: "项目资源图"
                },
            },
            {
                path: "/control_panel",
                name: "控制面板",
                component: () => import('../views/control_panel.vue'),
                // component: controlPanel,
                hidden: true,
                icon: '',
                meta: {
                    title: "控制面板"
                },
            },
            {
                path: "/control_panel_view",
                name: "控制面板详情",
                component: () => import('../views/control_panel_view.vue'),
                // component: controlPanelView,
                hidden: true,
                icon: '',
                meta: {
                    title: "控制面板详情"
                },
            },
            {
                path: "/control_panel_add",
                name: "新建控制面板",
                component: () => import('../views/control_panel_add.vue'),
                // component: controlPanelAdd,
                hidden: true,
                icon: '',
                meta: {
                    title: "新建控制面板"
                },
            },
            {
                path: "/project_add",
                name: "新建项目",
                component: () => import('../views/project_add.vue'),
                // component: projectAdd,
                hidden: true,
                icon: '',
                meta: {
                    title: "新建项目"
                },
            },
            {
                path: "/project_gantt",
                name: "项目甘特图",
                component: () => import('../views/project_gantt.vue'),
                // component: projectAdd,
                hidden: true,
                icon: '',
                meta: {
                    title: "项目甘特图"
                },
            },
            {
                path: "/project_detail_meeting1",
                name: "项目会议",
                component: () => import('../views/project_detail_meeting.vue'),

                hidden: true,
                icon: '',
                meta: {
                    title: "项目会议"
                },

            },

            {
                path: "/project_detail",
                name: "项目详情",
                component: () => import('../views/project_detail.vue'),
                // component: projectDetail,
                hidden: true,
                icon: '',
                meta: {
                    title: "项目详情",

                },
                children: [{
                    path: "/project_detail_infomation",
                    name: "项目详情-信息",
                    component: () => import('../views/project_detail_infomation.vue'),
                    // component: projectInfomation,
                    hidden: true,
                    icon: '',
                    meta: {
                        title: "项目详情-信息"
                    },
                },
                    {
                        path: "/project_detail_edit",
                        name: "项目详情-编辑",
                        component: () => import('../views/project_detail_edit.vue'),
                        // component: projectEditdit,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-编辑"
                        },
                    },
                    {
                        path: "/project_business_case",
                        name: "项目详情-商业案例",
                        component: () => import('../views/project_business_case.vue'),
                        // component: projectBusinessCase,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-商业案例"
                        },
                    },
                    {
                        path: "/project_detail_milestone",
                        name: "项目详情-里程碑",
                        component: () => import('../views/project_detail_milestone.vue'),
                        // component: projectMilestone,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-里程碑"
                        },
                    },
                    {
                        path: "/project_milestone_add",
                        name: "项目详情-里程碑-添加",
                        component: () => import('../views/project_milestone_add.vue'),
                        // component: projectMilestoneAdd,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-里程碑-添加"
                        },
                    },
                    {
                        path: "/project_detail_status",
                        name: "项目详情-状态",
                        component: () => import('../views/project_detail_status.vue'),
                        // component: projectStatus,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-状态"
                        },
                    },
                    {
                        path: "/project_detail_production",
                        name: "项目详情-文件",
                        component: () => import('../views/project_detail_production.vue'),
                        // component: projectStatus,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-文件"
                        },
                    },
                    {
                        path: "/project_status_update",
                        name: "项目详情-状态-更新",
                        component: () => import('../views/project_status_update.vue'),
                        // component: projectStatusUpdate,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-状态-更新"
                        },
                    },
                    {
                        path: "/project_detail_resource",
                        name: "项目详情-资源信息",
                        component: () => import('../views/project_detail_resource.vue'),
                        // component: projectResource,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-资源信息"
                        },
                    },
                    {
                        path: "/project_resource_update",
                        name: "项目详情-资源信息-更新",
                        component: () => import('../views/project_resource_update.vue'),
                        // component: projectResourceUpdate,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-资源信息-更新"
                        },
                    },
                    {
                        path: "/project_detail_board",
                        name: "项目详情-任务面板",
                        component: () => import('../views/project_detail_board.vue'),
                        // component: projectBoard,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-任务面板",

                        },
                        // children:[
                        //   {
                        //     path: "/project_task",
                        //     name: "项目详情-任务面板-详情",
                        //     component: () => import('../views/project_task.vue'),
                        //     // component: project_task,
                        //     hidden: true,
                        //     meta: {
                        //       title: "项目详情-任务面板-详情",

                        //     },
                        //   },
                        // ],
                    },
                    {
                        path: "/project_yuguchengben",
                        name: "项目费用",
                        component: () => import('../views/project_yuguchengben.vue'),
                        // component: project_yuguchengben,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目费用"
                        },
                    },
                    {
                        path: "/project_detail_meeting",
                        name: "项目会议",
                        component: () => import('../views/project_detail_meeting.vue'),

                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目会议"
                        },

                    },

                    {
                        path: "/project_task",
                        name: "项目详情-任务面板-详情",
                        component: () => import('../views/project_task.vue'),
                        // component: project_task,
                        hidden: true,
                        meta: {
                            title: "项目详情-任务面板-详情",

                        },
                    },
                    {
                        path: "/project_detail_setting",
                        name: "项目详情-设置",
                        component: () => import('../views/project_detail_setting.vue'),
                        // component: projectSetting,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-设置"
                        },
                    },
                    {
                        path: "/project_detail_activity",
                        name: "项目详情-活动",
                        component: () => import('../views/project_detail_activity.vue'),
                        // component: projectSetting,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-活动"
                        },
                    },
                    {
                        path: "/project_detail_Statistics",
                        name: "项目详情-统计",
                        component: () => import('../views/project_detail_Statistics.vue'),
                        // component: projectSetting,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-统计"
                        },
                    },
                    {
                        path: "/ganttNeed",
                        name: "项目甘特图",
                        component: () => import('../views/ganttNeed.vue'),
                        // component: projectSetting,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目甘特图"
                        },
                    },
                    {
                        path: "/gantt",
                        name: "项目甘特图",
                        component: () => import('../views/gantt.vue'),
                        // component: projectSetting,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目甘特图"
                        },
                    },
                    {
                        path: "/project_detail_map",
                        name: "项目详情-关系图",
                        component: () => import('../views/project_detail_map.vue'),
                        // component: projectMap,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-关系图"
                        },
                    },
                    {
                        path: "/project_detail_enclosure",
                        name: "项目详情-附件",
                        component: () => import('../views/project_detail_enclosure.vue'),
                        // component: projectMap,
                        hidden: true,
                        icon: '',
                        meta: {
                            title: "项目详情-附件"
                        },
                    },
                ]
            },
            {
                path: "/board_detail_info",
                name: "任务面板详情-修改",
                component: () => import('../views/board_detail_info.vue'),
                // component: boardDetailInfo,
                hidden: true,
                icon: '',
                meta: {
                    title: "任务面板详情-修改",

                },
            },
            {
                path: "/board_detail_info2",
                name: "任务面板详情-修改",
                component: () => import('../views/board_detail_info2.vue'),
                // component: boardDetailInfo,
                hidden: true,
                icon: '',
                meta: {
                    title: "任务面板详情-修改",

                },
            },
            {
                path: "/project_detail_meetingdetail",
                name: "会议详情",
                component: () => import('../views/project_detail_meetingdetail.vue'),

                hidden: true,
                icon: '',
                meta: {
                    title: "会议详情",

                },
            },
            {
                path: "/my_task",
                name: "我的任务",
                component: () => import('../views/my_task.vue'),
                // component: myTask,
                hidden: true,
                icon: '',
                meta: {
                    title: "我的任务",

                },
            },
            {
                path: "/my_task2",
                name: "我的任务",
                component: () => import('../views/my_task2.vue'),
                // component: myTask,
                hidden: true,
                icon: '',
                meta: {
                    title: "我的任务",

                },
            },
            {
                path: "/task_list",
                name: "全部任务",
                component: () => import('../views/task_list.vue'),
                // component: taskList,
                hidden: true,
                icon: '',
                meta: {
                    title: "全部任务"
                },
            },
            {
                path: "/history_message",
                name: "消息通知",
                component: () => import('../views/history_message.vue'),
                // component: historyMessage,
                hidden: true,
                icon: '',
                meta: {
                    title: "消息通知"
                },
            },
            {
                path: "/message_detail",
                name: "消息详情",
                component: () => import('../views/message_detail.vue'),
                // component: messageDetail,
                hidden: true,
                icon: '',
                meta: {
                    title: "消息详情"
                },
            },

            // {
            //   path: "/template",
            //   name: "模板",
            //   component: Template,
            //   icon:'iconfont icon-choosecar100',
            //   meta: {
            //     title: "模板"
            //   },
            // },

            // {
            //   path: "/task_panel_details",
            //   name: "任务面板详情",
            //   component: taskPanelDetails,
            //   hidden: true,
            //   meta: {
            //     title: "任务面板详情"
            //   },
            // },
            {
                path: "/project_task1",
                name: "任务面板详情",
                component: () => import('../views/project_task.vue'),
                // component: project_task,
                hidden: true,
                meta: {
                    title: "任务面板详情",

                },
            },
            {
                path: "/message_notice",
                name: "消息通知",
                icon: 'iconfont icon-xiaoxitongzhi',
                component: () => import('../views/message_notice.vue'),
                // component: messageNotice,
                meta: {
                    title: "消息通知"
                },
            },
            {
                path: "/my_activity",
                name: "我的全部活动",
                icon: 'iconfont icon-xiaoxitongzhi',
                // component: myActivity,
                component: () => import('../views/my_activity.vue'),
                meta: {
                    title: "我的全部活动",
                    content: {
                        viewport: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
                    }
                },


            },
            {
                path: "/project_border_detail_activity",
                name: "项目活动记录",
                icon: 'iconfont icon-xiaoxitongzhi',
                component: () => import('../views/project_border_detail_activity.vue'),
                // component: project_border_detail_activity,
                meta: {
                    title: "项目活动记录"
                },
            },
        ]
    },

    // 管理平台
    {
        path: "/main",
        name: "管理平台",
        component: () => import('../views/managementPlatform/main.vue'),
        // component: main,
        hidden: true,
        leaf: true,
        icon: 'el-icon-message',
        meta: {
            title: "管理平台"
        },
        children: [{
            path: "/role_management",
            name: "角色管理",
            icon: 'iconfont icon-ziyuan143',
            meta: {
                title: "角色管理"
            },
            component: () => import('../views/managementPlatform/role_management.vue'),
            // component:roleManagement,
        },
            {
                path: "/financial_management",
                name: "财务管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '财务管理'
                },
                component: () => import('../views/managementPlatform/financial_management.vue'),
                // component:financial_management,
            },
            {
                path: "/member_management",
                name: "成员管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '成员管理'
                },
                component: () => import('../views/managementPlatform/member_management.vue'),
                // component:memberMKanagement,
            },
            {
                path: "/main2",
                name: "配置管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '配置管理'
                },
                component: () => import('../views/managementPlatform/main2.vue'),
                // component:main2,
                children: [{
                    path: '/investment_portfolio',
                    component: () => import('../views/managementPlatform/investment_portfolio.vue'),
                    // component:investmentPortfolio,
                    name: "投资组合",
                    icon: 'iconfont icon-ziyuan143',
                    meta: {
                        title: '投资组合'
                    },
                },
                    {
                        path: '/holidaysCalendar',
                        component: () => import('../views/managementPlatform/holidaysCalendar.vue'),

                        name: "节假日配置",
                        icon: 'iconfont icon-ziyuan143',
                        meta: {
                            title: '节假日配置'
                        },
                    },
                    {
                        path: '/meetingRoomSetting',
                        component: () => import('../views/managementPlatform/meetingRoomSetting.vue'),

                        name: "会议室配置",
                        icon: 'iconfont icon-ziyuan143',
                        meta: {
                            title: '会议室配置'
                        },
                    },
                    {
                        path: '/project_process',
                        component: () => import('../views/managementPlatform/project_process.vue'),
                        // component:projectProcess,
                        name: "项目过程",
                        icon: 'iconfont icon-ziyuan143',
                        meta: {
                            title: '项目过程'
                        },
                    },
                ],
            },
            {
                path: "/project_management",
                name: "项目管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '项目管理'
                },
                component: () => import('../views/managementPlatform/project_management.vue'),
                // component:projectManagement,
            },
            {
                path: "/approveSeeting",
                name: "审批管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '审批管理'
                },
                component: () => import('../views/managementPlatform/approveSeeting.vue'),

            },
            {
                path: "/task_management",
                name: "任务面板",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '任务面板'
                },
                component: () => import('../views/managementPlatform/task_management.vue'),
                // component:taskManagement,
            },
            {
                path: "/main2",
                name: "订阅管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '订阅管理'
                },
                component: () => import('../views/managementPlatform/main2.vue'),
                // component:main2,
                children: [{
                    path: '/subscribe_record',
                    component: () => import('../views/managementPlatform/subscribe_record.vue'),
                    // component:subscribeRecord,
                    name: "订阅记录",
                    icon: 'iconfont icon-ziyuan143',
                    meta: {
                        title: '订阅记录'
                    },
                },
                    {
                        path: '/subscribe_management',
                        component: () => import('../views/managementPlatform/subscribe_management.vue'),
                        // component:subscribeManagement,
                        name: "订阅管理",
                        icon: 'iconfont icon-ziyuan143',
                        meta: {
                            title: '订阅管理'
                        },
                    },
                ],
            },
            {
                path: "/payment",
                name: "支付页面",
                component: () => import('../views/managementPlatform/payment.vue'),
                // component: payment,
                hidden: true,
                meta: {
                    title: "支付页面"
                }
            },
            {
                path: "/business_info",
                name: "企业信息",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '企业信息'
                },
                component: () => import('../views/managementPlatform/business_info.vue'),
                // component:businessInfo,
            },
            {
                path: "/deviceManage",
                name: "设备管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '设备管理'
                },
                component: () => import('../views/managementPlatform/deviceManage.vue'),
                // component:businessInfo,
            },
            {
                path: "/history_message_manage",
                name: "消息通知",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '消息通知'
                },
                component: () => import('../views/managementPlatform/history_message_manage.vue'),
                // component:historyMessageManage,
            },
            {
                path: "/message_detail_manage",
                name: "消息详情",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '消息详情'
                },
                component: () => import('../views/managementPlatform/message_detail_manage.vue'),
                // component:messageDetailManage,
            },
            {
                path: "/askForLeaveManagement",
                name: "请假管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '请假管理'
                },
                component: () => import('../views/managementPlatform/askForLeaveManagement.vue'),
                // component:financial_management,
            },
            {
                path: "/overtimeManagement",
                name: "加班管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '加班管理'
                },
                component: () => import('../views/managementPlatform/overtimeManagement.vue'),
                // component:financial_management,
            },
            {
                path: "/expensesManage",
                name: "报销管理",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '报销管理'
                },
                component: () => import('../views/managementPlatform/ExpensesManage.vue'),
                // component:financial_management,
            },
            {
                path: "/applicationCenter",
                name: "应用中心",
                icon: 'iconfont icon-ziyuan143',
                meta: {
                    title: '应用中心'
                },
                component: () => import('../views/managementPlatform/applicationCenter/applicationCenter.vue'),
                // component:main2,
                children: [
                    {
                        path: '/applicationCenterindex',
                        component: () => import('../views/managementPlatform/applicationCenter/applicationCenterindex.vue'),
                        // component:projectProcess,
                        name: "应用市场",
                        icon: 'iconfont icon-ziyuan143',
                        meta: {
                            title: '应用市场'
                        },
                    },
                    {
                        path: '/subscribedApps',
                        component: () => import('../views/managementPlatform/applicationCenter/subscribedApps.vue'),
                        // component:projectProcess,
                        name: "已订阅应用",
                        icon: 'iconfont icon-ziyuan143',
                        meta: {
                            title: '已订阅应用'
                        },
                    },
                ],
            },
        ]
    },
    // {
    //   path: "/payment",
    //   name: "支付页面",
    //   component: payment,
    //   hidden:true,
    //   meta: {
    //     title: "支付页面"
    //   }
    // },
    // {
    //   path: "/about",
    //   name: "About",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/About.vue")
    // }
    { path: '*', redirect: '/404' },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeResolve((to, from, next) => {
    ensureWechatSdk().then(() => next()).catch(() => next());
});
export default router;
